var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-padding"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline box"},[_vm._m(0),_c('div',{staticClass:"column is-12"},[_c('List')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-12"},[_c('h1',{staticClass:"title"},[_vm._v("Prospectos a socios")])])
}]

export { render, staticRenderFns }